var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDogeBoxDeskFront(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 539,
    height: 129,
    viewBox: "0 0 539 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3298 98.7599L22.2198 91.8599L22.0998 98.7599H15.3298Z",
    fill: "#D2B367"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4638 91.2845C22.6985 91.384 22.8492 91.6159 22.8448 91.8707L22.7248 98.7708C22.7188 99.1116 22.4408 99.3849 22.0999 99.3849H15.3299C15.0771 99.3849 14.8493 99.2327 14.7525 98.9993C14.6557 98.7658 14.709 98.4971 14.8876 98.3183L21.7776 91.4183C21.9577 91.2379 22.2292 91.185 22.4638 91.2845ZM16.8372 98.1349H21.4856L21.568 93.3972L16.8372 98.1349Z",
    fill: "#020202"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M14.4299 98.7599L21.3199 91.8599L21.1999 98.7599H14.4299Z",
    fill: "#020202"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M524.02 70.8699H521.12V73.6699L524.02 70.8699Z",
    fill: "#020202"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M520.495 70.8699C520.495 70.5247 520.775 70.2449 521.12 70.2449H524.02C524.275 70.2449 524.504 70.3995 524.599 70.6358C524.695 70.872 524.637 71.1425 524.454 71.3195L521.554 74.1195C521.374 74.2937 521.106 74.3432 520.876 74.2452C520.645 74.1472 520.495 73.9207 520.495 73.6699V70.8699ZM521.745 71.4949V72.1977L522.473 71.4949H521.745Z",
    fill: "#020202"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M521.12 15.9199L491.12 46.1699V108.67L521.12 78.4199V15.9199Z",
    fill: "#F9F0DC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.358 15.342C521.592 15.4385 521.745 15.6667 521.745 15.9199V78.4199C521.745 78.5848 521.68 78.743 521.564 78.8601L491.564 109.11C491.385 109.29 491.116 109.344 490.882 109.248C490.648 109.151 490.495 108.923 490.495 108.67V46.1699C490.495 46.0051 490.56 45.8469 490.676 45.7298L520.676 15.4798C520.854 15.3 521.124 15.2456 521.358 15.342ZM491.745 46.4273V107.152L520.495 78.1626V17.4377L491.745 46.4273Z",
    fill: "#020202"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.56 24.0963C521.805 24.3393 521.807 24.7351 521.564 24.9801L491.564 55.2301C491.321 55.4752 490.925 55.4769 490.68 55.2338C490.435 54.9907 490.433 54.595 490.676 54.3499L520.676 24.0999C520.919 23.8548 521.315 23.8532 521.56 24.0963Z",
    fill: "#020202"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.56 33.3062C521.805 33.5493 521.807 33.945 521.564 34.1901L491.564 64.4401C491.321 64.6852 490.925 64.6868 490.68 64.4438C490.435 64.2007 490.433 63.805 490.676 63.5599L520.676 33.3099C520.919 33.0648 521.315 33.0632 521.56 33.3062Z",
    fill: "#020202"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.56 43.8262C521.805 44.0693 521.807 44.465 521.564 44.7101L491.564 74.9601C491.321 75.2052 490.925 75.2069 490.68 74.9638C490.435 74.7207 490.433 74.325 490.676 74.0799L520.676 43.8299C520.919 43.5848 521.315 43.5832 521.56 43.8262Z",
    fill: "#020202"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.56 53.0363C521.805 53.2794 521.807 53.6751 521.564 53.9202L491.564 84.1602C491.32 84.4052 490.925 84.4068 490.68 84.1637C490.435 83.9206 490.433 83.5248 490.676 83.2798L520.676 53.0398C520.919 52.7948 521.315 52.7932 521.56 53.0363Z",
    fill: "#020202"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.56 62.7462C521.805 62.9892 521.807 63.385 521.564 63.63L491.564 93.88C491.321 94.1251 490.925 94.1268 490.68 93.8837C490.435 93.6406 490.433 93.2449 490.676 92.9998L520.676 62.7498C520.919 62.5047 521.315 62.5031 521.56 62.7462Z",
    fill: "#020202"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M491.11 46.1699H22.0999V108.67H491.11V46.1699Z",
    fill: "#F9F0DC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4749 46.1699C21.4749 45.8247 21.7547 45.5449 22.0999 45.5449H491.11C491.455 45.5449 491.735 45.8247 491.735 46.1699V108.67C491.735 109.015 491.455 109.295 491.11 109.295H22.0999C21.7547 109.295 21.4749 109.015 21.4749 108.67V46.1699ZM22.7249 46.7949V108.045H490.485V46.7949H22.7249Z",
    fill: "#020202"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M495.09 98.76H15.3298V112.65H495.09V98.76Z",
    fill: "#D2B367"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7048 98.76C14.7048 98.4148 14.9847 98.135 15.3298 98.135H495.09C495.435 98.135 495.715 98.4148 495.715 98.76V112.65C495.715 112.995 495.435 113.275 495.09 113.275H15.3298C14.9847 113.275 14.7048 112.995 14.7048 112.65V98.76ZM15.9548 99.385V112.025H494.465V99.385H15.9548Z",
    fill: "#020202"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M524.02 83.8099L495.08 112.65V98.7599L524.02 70.8699V83.8099Z",
    fill: "#D2B367"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M524.264 70.2947C524.495 70.3928 524.645 70.6192 524.645 70.8699V83.8099C524.645 83.976 524.579 84.1353 524.461 84.2526L495.521 113.093C495.342 113.271 495.073 113.324 494.84 113.227C494.607 113.13 494.455 112.902 494.455 112.65V98.7599C494.455 98.5901 494.524 98.4277 494.646 98.3099L523.586 70.4199C523.767 70.2459 524.034 70.1966 524.264 70.2947ZM495.705 99.0256V111.145L523.395 83.5504V72.3402L495.705 99.0256Z",
    fill: "#020202"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M524.02 83.8099L495.08 112.65V98.7599L524.02 70.8699V83.8099Z",
    fill: "#020202"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogeBoxDeskFront);
export default __webpack_public_path__ + "static/media/doge-box-desk-front.33bdacefd497db2ee79aaf86ef0576a0.svg";
export { ForwardRef as ReactComponent };